module.exports = ".company-detail strong{\n    display: block;\n    margin-top: 12px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/companies/company-temporary/company-temporary.component.css
// module id = ./src/app/views/companies/company-temporary/company-temporary.component.css
// module chunks = main